/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { closeAllTooltips } from './page-tooltips.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';

import { MDTrees } from './tree-data.js';
import { MVTrees } from './trees.js';


(function($,mj) {

	/**
	 * Manja Category Tree Widget ( .mjCategoryTreeWidget )
	 *
	 * methods:
	 *  - init(opts)
	 *  - destroy()
	 *
	 * usage:
	 *  $('#container').mjCategoryTreeWidget( { ... } )
	 *
	 */
	$.widget( 'mj.mjCategoryTreeWidget', {

		options: {
			tree_id: null,
			// tree: null,

			// function( dt )
			onAfterCreate: null,

			// function( ondone_cb )
			onAfterTreeStructureChange: null,
			// function( create_nodes, update_nodes, delete_nodes, ondone_cb )
			onAfterTreeNodeCRUDAction: null,

			// example: only enable those nodes for which user has upload-permissions:
			// onAfterTreeNodeCRUDAction: function( create_nodes, update_nodes, delete_nodes, ondone_cb ) {
			// 	this.disableAllNodes();
			// 	MDTrees.refreshTreeData( function() {
			// 		if( mj.upload_categories && mj.upload_categories.length>0 ) {
			// 			thisWidget.setNodesEnabled(mj.upload_categories);
			// 			if( ondone_cb ) ondone_cb.call(thisWidget,mj.upload_categories);
			// 		}
			// 	} );
			// }

			// function()
			onSelectionChange: null,

			initialSelection: null,

			dynaTree: {
				idPrefix: 'xx-cat-node-',
			},

			contextMenu: {
				enabled: false,
				menu_type: 'unknown',
				dialog_elem: null,
			},

		},


		_create: function() {
			this._setupDynaTree(true,false,false);
		},
		_destroy: function() {
			var dti = this.element.dynatree('instance');
			this._internalDestroy(dti);
		},
		_setOption: function( k, v ) {
			this._super( k, v );
			// TODO
		},

		_internalDestroy: function( dti ) {
			// remove all event handlers
			this.element.off('.mjCategoryTreeWidget');
			// remove context menu
			this._removeContextMenu();
			// destroy contained dynatree widget
			if( dti ) this.element.dynatree('destroy');
			// remove all created elements
			this.element.empty();
		},


		recreate: function( restore_selection, update_node_states ) {
			this._setupDynaTree(true,restore_selection,update_node_states);
		},

		disableAllNodes: function() {
			var dt = this.getDynaTree();
			if( !dt ) return; // instance gone
			dt.getRoot().disableAll();
		},

		setNodesEnabled: function( node_ids ) {
			var dt = this.getDynaTree();
			if( !dt ) return; // instance gone
			for( var i=0; i<node_ids.length; ++i ) {
				var dtnode = dt.getNodeByKey(node_ids[i]);
				if( dtnode!==null ) dtnode.enable();
			}
		},

		getDynaTree: function() {
			var dti = this.element.dynatree('instance');
			return dti ? dti.getTree() : null;
		},

		getSelectedCategoryIds: function() {
			var dt = this.getDynaTree();
			if( !dt ) return []; // instance gone
			return dt.getSelectedKeys();
		},

		setSelection: function( category_ids, noCallEvent ) {
			var dt = this.getDynaTree();
			if( !dt ) return; // instance gone
			dt.setSelection(category_ids,noCallEvent);
			if( !noCallEvent && this.options.onSelectionChange ) this.options.onSelectionChange.call(this);
		},

		afterTreeStructureChange: function( ondone_cb ) {
			if( this.options.onAfterTreeStructureChange ) {
				return this.options.onAfterTreeStructureChange.call(this,ondone_cb);
			}
			if( ondone_cb ) return ondone_cb.call(this);
		},

		afterTreeNodeCRUDAction: function( create_nodes, update_nodes, delete_nodes, ondone_cb ) {
			if( this.options.onAfterTreeNodeCRUDAction ) {
				return this.options.onAfterTreeNodeCRUDAction.call(this,create_nodes,update_nodes,delete_nodes,ondone_cb);
			}
			if( ondone_cb ) return ondone_cb.call(this);
		},


		_setupContextMenu: function() {
			var ctxmo = this.options.contextMenu;
			if( ctxmo.enabled ) {
				return MVTrees.setupContextMenuOnCategoryTree( this.element, ctxmo.menu_type, ctxmo.dialog_elem );
			}
		},

		_removeContextMenu: function() {
			if( this.options.contextMenu.enabled ) {
				return MVTrees.removeContextMenuFromCategoryTree( this.element );
			}
		},

		_setupDynaTree: function( destroy_previous, restore_selection, update_node_states ) {

			var tree_id = this.options.tree_id;
			var tree = mj.trees[tree_id];
			var dti = this.element.dynatree('instance');
			// console.log(tree);

			var selected_categories = [];
			if( restore_selection ) {
				if( dti ) selected_categories = dti.getTree().getSelectedKeys();
				// console.log(['selected_categories',selected_categories]);
			}
			if( destroy_previous ) {
				// destroy previous dynatree widget
				this._internalDestroy(dti);
			}

			// setup new dynatree widget
			var thisWidget = this;
			var dt_opts = {
				children: MDTrees.getDynatreeObjectFromTree(tree_id,tree_id==1?false:true,false),
				persist: true,
				mjTreeId: tree_id,
				cookieId: 'mj-cdt-u-'+tree_id,
				cookieOpts: mj.cookieopts,
				idPrefix: 'ctw-cat-node-'+tree_id+'-',
				autoSelectChildren: false,
				multiSelect: !!tree.multifiling,
				nodeHREF: mj.uwn+'/media#category=%key%',
				onSelect: function( dtnode ) {
					// expand - show child categories
					dtnode._expand(true);
					// collapse all siblings (this avoids that the "whole tree" is expanded after some browsing through it)
					dtnode.collapseSiblings();
					// somehow, here the jquery ui tooltip widget does not update properly,
					// - so, remove all tooltips manually ...
					closeAllTooltips();
					if( tree.multifiling ) {
						// ensure that selecting "unsorted" category will not combine with other categories ..
						if( dtnode.data.key == 0 ) {
							// selected "unsorted" category
							// -> unselect other nodes
							dtnode.tree.unselectAllNodes();
							// select self again
							dtnode.select(null,null,true);
						} else {
							// selected any other category
							// -> unselect "0" node - if existing
							dtnode.tree.unselectKey(0);
						}
					}
					if( thisWidget.options.onSelectionChange ) thisWidget.options.onSelectionChange.call(thisWidget);
				},
				onAfterDelayedCreate: function( dt ) {
					var _do_restore_selection = null;
					if( restore_selection ) {
						_do_restore_selection = function() {
							var dt = this.getDynaTree();
							if( !dt ) return; // instance gone
							dt.setSelection(selected_categories,true);
						};
					}
					if( tree_id==1 && update_node_states ) {
						thisWidget.afterTreeStructureChange(_do_restore_selection);
					} else {
						if( _do_restore_selection ) _do_restore_selection.call(thisWidget);
					}

					// setup context menu on widget
					thisWidget._setupContextMenu();

					if( !restore_selection && thisWidget.options.initialSelection ) {
						thisWidget.setSelection(thisWidget.options.initialSelection,true);
					}

					if( thisWidget.options.onAfterCreate ) {
						thisWidget.options.onAfterCreate.call(thisWidget,dt);
					}

					// trigger onSelectionChange once
					if( thisWidget.options.onSelectionChange ) thisWidget.options.onSelectionChange.call(thisWidget);

				},
			};
			Object.assign(dt_opts,this.options.dynaTree);
			this.element.dynatree(dt_opts);

		},
	} );	// $.widget( 'mj.mjCategoryTreeWidget',

})(jQuery,mj);



export function buildContextMenuOptionsForCategoryTree( menu_type, templateElementId, cssClassName ) {
	const ctx_menu_options = {
		appendTo: '#page',
		templateElementId,
		cssClassName,
		bindings: {
			// manager or administrator role
			'media-ctxm-cat-edit':			function(t) {
				MVTrees.execCategoryMenuAction('edit',t,menu_type);
			},
			'media-ctxm-cat-sort':			function(t) {
				MVTrees.execCategoryMenuAction('sort',t,menu_type);
			},
			'media-ctxm-cat-sort-contents':	function(t) {
				MVTrees.execCategoryMenuAction('sort-contents',t,menu_type);
			},
			'media-ctxm-cat-move':			function(t) {
				MVTrees.execCategoryMenuAction('move',t,menu_type);
			},
			'media-ctxm-cat-add':			function(t) {
				MVTrees.execCategoryMenuAction('add',t,menu_type);
			},
			'media-ctxm-cat-delete':		function(t) {
				MVTrees.execCategoryMenuAction('delete',t,menu_type);
			},
		},
		onShowMenu: function(e,menu) {
			return MVTrees.onShowContextMenu(e,menu,menu_type);
		},
		onHideMenu: function(menu) {
		},
	};
	return ctx_menu_options;
}

